import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { SnackbarProvider } from "notistack"; // Import SnackbarProvider

// DigitalPass Context Provider
import { DigitalPassControllerProvider } from "context";

const container = document.getElementById("app");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <DigitalPassControllerProvider>
      <SnackbarProvider
        autoHideDuration={4000}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <App />
      </SnackbarProvider>
    </DigitalPassControllerProvider>
  </BrowserRouter>
);
